<section [class.closeAnimation]="quickSearchSrv.isCloseAnimation" (click)="closeQuickSearch()" [ngClass]="{'dark': (darkmode.isDarkMode | async), 'light': !(darkmode.isDarkMode | async) }">
  <div id="box" (click)="stopCloseEvent($event)">

    <div class="search">
      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="search" class="search-icon svg-inline--fa fa-search fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#B2B2B2" d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"></path></svg>
      <input #search type="search" [(ngModel)]="searchText" (keyup)="searchTickets($event)"  class="search-input" placeholder="Tickets, Kunden, Inhalte..."/>
    </div>

    @if (isLoading) {
      <div id="content-spinner">
        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="spinner-third" class="svg-inline--fa fa-spinner-third fa-w-16 spinner" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M283.2 65.92C267.6 63.69 256 50.32 256 34.52c0-19.38 17.19-34.69 36.38-31.95C416.4 20.29 512 127.2 512 256c0 33.38-6.544 65.26-18.27 94.49c-7.162 17.86-28.85 24.87-45.56 15.32c-13.74-7.854-19.62-24.53-13.75-39.23C443.2 304.7 448 280.9 448 256C448 159.4 376.3 79.18 283.2 65.92z"></path></svg>
      </div>
    }

    @if (searchText == '' && tickets.length == 0 && crms.length == 0 && content.length == 0) {
      <div id="no-search-value">
        @if (recentlySearched.length == 0) {
          <div class="no-content">
            Suchen Sie nach Tickets, Ticketinhalten oder nach Kunden.
          </div>
        }
        @if (recentlySearched.length > 0) {
          <div class="lastSearchValues">
            <div>
              <h3>Letzte Suchanfragen</h3>
              <h3 (click)="deleteRecentlyItems()">Löschen</h3>
            </div>
            @for (rs of recentlySearched; track rs) {
              <ion-item (click)="recentlyItemClicked(rs)">
                <svg slot="start" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="timer" class="svg-inline--fa fa-timer" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 184.4 29.46 119.6 76.84 73.14C89.46 60.78 109.7 60.98 122.1 73.6C134.5 86.23 134.3 106.5 121.6 118.9C86.03 153.7 64 202.3 64 256C64 362 149.1 448 256 448C362 448 448 362 448 256C448 160.9 378.8 81.89 288 66.65V96C288 113.7 273.7 128 256 128C238.3 128 224 113.7 224 96V32C224 14.33 238.3 0 256 0C397.4 0 512 114.6 512 256zM272.1 239C282.3 248.4 282.3 263.6 272.1 272.1C263.6 282.3 248.4 282.3 239 272.1L159 192.1C149.7 183.6 149.7 168.4 159 159C168.4 149.7 183.6 149.7 192.1 159L272.1 239z"></path></svg>
                <ion-label>{{rs}}</ion-label>
              </ion-item>
            }
          </div>
        }
      </div>
    }


    @if (!isLoading) {
      <div id="with-search-text">
        @if (tickets.length > 0) {
          <div id="tickets">
            <h3>Tickets</h3>
            @for (ticket of tickets; track ticket) {
              <ion-item (click)="openTicket(ticket)">
                <svg slot="start" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="ticket" class="svg-inline--fa fa-ticket" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M128 160H448V352H128V160zM512 64C547.3 64 576 92.65 576 128V208C549.5 208 528 229.5 528 256C528 282.5 549.5 304 576 304V384C576 419.3 547.3 448 512 448H64C28.65 448 0 419.3 0 384V304C26.51 304 48 282.5 48 256C48 229.5 26.51 208 0 208V128C0 92.65 28.65 64 64 64H512zM96 352C96 369.7 110.3 384 128 384H448C465.7 384 480 369.7 480 352V160C480 142.3 465.7 128 448 128H128C110.3 128 96 142.3 96 160V352z"></path></svg>
                <ion-label>
                  {{ticket.description}}
                </ion-label>
              </ion-item>
            }
          </div>
        }
        @if (crms.length > 0) {
          <div id="crms" >
            <h3>Kunden</h3>
            @for (crm of crms; track crm) {
              <ion-item (click)="openCrm(crm)">
                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user-tie" class="svg-inline--fa fa-user-tie" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M352 128C352 198.7 294.7 256 224 256C153.3 256 96 198.7 96 128C96 57.31 153.3 0 224 0C294.7 0 352 57.31 352 128zM209.1 359.2L176 304H272L238.9 359.2L272.2 483.1L311.7 321.9C388.9 333.9 448 400.7 448 481.3C448 498.2 434.2 512 417.3 512H30.72C13.75 512 0 498.2 0 481.3C0 400.7 59.09 333.9 136.3 321.9L175.8 483.1L209.1 359.2z"></path></svg>
                <ion-label>
                  {{crm.description}}
                </ion-label>
              </ion-item>
            }
          </div>
        }
        @if (content.length > 0) {
          <div id="content">
            <h3>Inhalte</h3>
            @for (c of content; track c) {
              <ion-item (click)="openTicketContent(c)">
                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="align-left" class="svg-inline--fa fa-align-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M256 96H32C14.33 96 0 81.67 0 64C0 46.33 14.33 32 32 32H256C273.7 32 288 46.33 288 64C288 81.67 273.7 96 256 96zM256 352H32C14.33 352 0 337.7 0 320C0 302.3 14.33 288 32 288H256C273.7 288 288 302.3 288 320C288 337.7 273.7 352 256 352zM0 192C0 174.3 14.33 160 32 160H416C433.7 160 448 174.3 448 192C448 209.7 433.7 224 416 224H32C14.33 224 0 209.7 0 192zM416 480H32C14.33 480 0 465.7 0 448C0 430.3 14.33 416 32 416H416C433.7 416 448 430.3 448 448C448 465.7 433.7 480 416 480z"></path></svg>
                <ion-label>
                  <h2>{{c.ticket.description}}</h2>
                  <p [innerHTML]="c.content | safeHtml: true"></p>
                </ion-label>
              </ion-item>
            }
          </div>
        }
      </div>
    }

    @if (tickets.length == 0 && crms.length == 0 && content.length == 0 && searchText != '' && !isLoading ) {
      <div class="no-content">
        Keine Einträge gefunden.<br>
        <span style="font-weight: 300; font-size: 15px;">Bitte versuchen Sie einen anderen Suchtext</span>
      </div>
    }


    <div id="introduction">

      <div class="introduction-item">
        <div>esc</div>
        <div>Schließen</div>
      </div>
      <div class="introduction-item">
        @if (isMac) {
          <div>
            <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="command" class="svg-inline--fa fa-command" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M352 288h-32V224h32c52.94 0 96-43.06 96-96s-43.06-96-96-96s-96 43.06-96 96v32H192V128c0-52.94-43.06-96-96-96S0 75.06 0 128s43.06 96 96 96h32v64H96c-52.94 0-96 43.06-96 96s43.06 96 96 96s96-43.06 96-96v-32h64v32c0 52.94 43.06 96 96 96s96-43.06 96-96S404.9 288 352 288zM320 128c0-17.66 14.34-32 32-32s32 14.34 32 32s-14.34 32-32 32h-32V128zM128 384c0 17.66-14.34 32-32 32s-32-14.34-32-32s14.34-32 32-32h32V384zM128 160H96C78.34 160 64 145.7 64 128s14.34-32 32-32s32 14.34 32 32V160zM256 288H192V224h64V288zM352 416c-17.66 0-32-14.34-32-32v-32h32c17.66 0 32 14.34 32 32S369.7 416 352 416z"></path></svg>
            + P
          </div>
        }
        @if (!isMac) {
          <div>
            Strg + P
          </div>
        }
        <div>Öffnen/Schließen</div>
      </div>

    </div>

  </div>
</section>